import { motion } from 'framer-motion'
import { PropsWithChildren } from 'react'

interface Props extends PropsWithChildren {
  key: string
}

export const FundingActionTextWrapper: React.FC<Props> = (props) => {
  const { children, key } = props

  return (
    <motion.div
      key={key}
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      {children}
    </motion.div>
  )
}
